import { environment } from '../../../environments/environment';

export const BASE_URL: string = environment.apiBaseUrl;
export const BASE_URL_V2: string = environment.apiBaseUrlV2;

export let BASE_FE_URL: string;
if (window.location.href.indexOf('www') > 0) {
  BASE_FE_URL = environment.frontendBaseUrlWithWww;
} else {
  BASE_FE_URL = environment.frontendBaseUrlWithoutWww;
}



// WEBPACK FOOTER //
// ./src/app/core/services/api.ts